<div class="card">
  <div class="img-container">
    <tg-avatar [uid]="player.uid"></tg-avatar>
  </div>
  <app-ripple-mat-card>
    {{ player.name }}
  </app-ripple-mat-card>
</div>
